import { styled, Flex, StyleSystemProps } from '@withjoy/joykit';

export const StyledTotalGiftCountWrapper = styled(Flex)``;
const totalGiftCountWrapperStyles: StyleSystemProps = {
  alignItems: 'center'
};

export const StyledTotalProgressTextWrapper = styled(Flex)``;
const totalProgressTextWrapperStyles: StyleSystemProps = {
  alignItems: 'center',
  marginBottom: 5
};

export const styles = {
  totalGiftCountWrapper: totalGiftCountWrapperStyles,
  totalProgressTextWrapper: totalProgressTextWrapperStyles
};
